import React, { useEffect, useState } from 'react'
import {
    Box,
    Card,
    Container,
    Grid,
    CardContent,
    Typography,
} from '@mui/material';
import invoice from '../Assests/invoice.png'
import money from '../Assests/money.png'
import people from '../Assests/people.png'
import analytics from '../Assests/analytics.png'
import axios from 'axios';

function SystemAnalysis() {
    const [totalShop1InvoiceCount, setTotalShop1InvoiceCount] = useState(0);
    const [totalShop2InvoiceCount, setTotalShop2InvoiceCount] = useState(0);
    const [totalShop3InvoiceCount, setTotalShop3InvoiceCount] = useState(0);
    const [getDate, setGetDate] = useState(new Date().toISOString().substring(0, 10));
    const [totalShop1Sale, setTotalShop1Sale] = useState("0");
    const [totalShop2Sale, setTotalShop2Sale] = useState("0");
    const [totalShop3Sale, setTotalShop3Sale] = useState("0");
    const [netTotalShop1Sale, setNetTotalShop1Sale] = useState("0");
    const [netTotalShop2Sale, setNetTotalShop2Sale] = useState("0");
    const [netTotalShop3Sale, setNetTotalShop3Sale] = useState("0");
    const [activeSupplierCount, setActiveSupplierCount] = useState();

    useEffect(() => {
        GetTotalInvoices();
        GetMonthlyTotalSalesCount();
        GetNetTotalSales();
        GetAllSupplierCount();
    }, [])

    function GetTotalInvoices() {
        axios.get('https://serverfourpaws.ccsoftwares.com/billing/GetTotalInvoices').then((res) => {
            setTotalShop1InvoiceCount(res.data[0].totalInvoiceCount_Shop1);
            setTotalShop2InvoiceCount(res.data[0].totalInvoiceCount_Shop2);
            setTotalShop3InvoiceCount(res.data[0].totalInvoiceCount_Shop3);
        })
    }

    function GetMonthlyTotalSalesCount() {
        axios.get(`https://serverfourpaws.ccsoftwares.com/billing/GetMonthlyTotalSales/${getDate}`).then((res) => {
            setTotalShop1Sale(res.data[0].totalSales_Shop1);
            setTotalShop2Sale(res.data[0].totalSales_Shop2);
            setTotalShop3Sale(res.data[0].totalSales_Shop3);
        })
    }

    function GetNetTotalSales() {
        axios.get('https://serverfourpaws.ccsoftwares.com/billing/GetNetTotalSales').then((res) => {
            setNetTotalShop1Sale(res.data[0].totalSales_Shop1);
            setNetTotalShop2Sale(res.data[0].totalSales_Shop2);
            setNetTotalShop3Sale(res.data[0].totalSales_Shop3);
        })
    }

    function GetAllSupplierCount() {
        axios.get('https://serverfourpaws.ccsoftwares.com/billing/GetAllSupplierCount').then((res) => {
            setActiveSupplierCount(res.data[0].SupplierCount);
        })
    }

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Box mt={0}>
                    <Card sx={{ padding: '15px' }}>
                        <Grid container spacing={1}>
                            <Grid item md={3} xs={12} >
                                <Card sx={{ maxWidth: 345, background: '#FEFF9F', padding: '10px' }}>
                                    <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Rathnapura : {totalShop1InvoiceCount}
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Kalawana : {totalShop2InvoiceCount}
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Palmadulla : {totalShop3InvoiceCount}
                                            </Typography>
                                        </Box>

                                        <img
                                            src={invoice}
                                            height='50px'
                                            style={{ opacity: '0.7' }}
                                        />
                                    </CardContent>
                                    <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontFamily: 'Oswald, serif' }} >
                                        Total Invoices
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item md={3} xs={12} >
                                <Card sx={{ maxWidth: 345, height: 143.5, background: '#A1EEBD', padding: '10px' }}>
                                    <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Rathnapura : {totalShop1Sale} LKR
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Kalawana : {totalShop2Sale}
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Palmadulla : {totalShop3Sale}
                                            </Typography>
                                        </Box>

                                        <img
                                            src={analytics}
                                            height='50px'
                                            style={{ opacity: '0.7' }}
                                        />
                                    </CardContent>
                                    <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontFamily: 'Oswald, serif' }} >
                                        Monthly Sales
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Card sx={{ maxWidth: 345, background: '#C9E6F0', padding: '10px' }}>
                                    <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Rathnapura : {netTotalShop1Sale} LKR
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Kalawana : {netTotalShop2Sale}
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                Palmadulla : {netTotalShop3Sale}
                                            </Typography>
                                        </Box>

                                        <img
                                            src={money}
                                            height='50px'
                                            style={{ opacity: '0.7' }}
                                        />
                                    </CardContent>
                                    <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontFamily: 'Oswald, serif' }} >
                                        Total Sales
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Card sx={{ maxWidth: 345, height: 143.5, background: '#C9E6F0', padding: '10px' }}>
                                    <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '30px', textAlign: 'center', fontWeight: 'bold', }}>
                                                {activeSupplierCount}
                                            </Typography>
                                        </Box>

                                        <img
                                            src={people}
                                            height='60px'
                                            style={{ opacity: '0.7' }}
                                        />
                                    </CardContent>
                                    <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontFamily: 'Oswald, serif' }} >
                                        Total Suppliers
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <h1>hello</h1>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <h1>hello</h1>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <h1>hello</h1>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <h1>hello</h1>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>
            </Container >

        </>
    )
}

export default SystemAnalysis